import { useRef } from "react";

const SidebarMenuItem = ({
  item,
  menuRefs,
  handleToggleMenu,
  openMenus,
  calculatePosition,
  hoveredMenu,
  handleMouseEnter,
  handleMouseLeave,
}) => {
  const menuRef = useRef(null);
  menuRefs.current[item.label] = menuRef;

  const handleSubMenuHover = () => {
    handleMouseEnter(item.label);
  };

  const handleSubMenuLeave = () => {
    handleMouseLeave();
  };

  return (
    <li
      key={item.label}
      ref={menuRef}
      onMouseEnter={handleSubMenuHover}
      onMouseLeave={handleSubMenuLeave}
      className={item.active ? "active" : ""}
    >
      <a
        href={item.link}
        onClick={(e) => {
          if (item.onClick) {
            e.preventDefault();
            item.onClick();
          } else if (item.children.length) {
            e.preventDefault();
            handleToggleMenu(item.label);
          }
        }}
        title={item.label}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          fontSize: "12px",
          alignItems: "center",
        }}
      >
        <em className={item.icon}></em>
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
          }}
        >
          {item.label}
        </div>
      </a>

      {/* Conditionally render submenu based on hover or click */}
      {item.children.length > 0 &&
        (openMenus[item.label] || hoveredMenu === item.label) && (
          <ul
            className="nav sidebar-subnav nav-floating"
            style={{
              position: "absolute",
              top: calculatePosition(menuRefs.current[item.label]).top,
              left: calculatePosition(menuRefs.current[item.label]).left,
              width: "200px",
              zIndex: "10",
              fontSize: "12px",
              marginTop: "0px",
              marginLeft: "10px",
            }}
          >
            {item.children.map((child) => (
              <li key={child.label}>
                <a href={child.link} title={child.label}>
                  <span>{child.label}</span>
                </a>
              </li>
            ))}
          </ul>
        )}
    </li>
  );
};

export default SidebarMenuItem;
